import {
  WEEKDAY_CHART_PRESETS,
  WEEKLY_CHART_PRESETS,
  SINGLE_DAY_PRESETS
} from "./widgetConstants";


export const buildChartData = (series = [], preset) => {
  if (SINGLE_DAY_PRESETS.has(preset)) {
    return buildSingleDayBucket(series, preset);
  }

  if (WEEKDAY_CHART_PRESETS.has(preset) || WEEKLY_CHART_PRESETS.has(preset)) {
    return buildDailyPoints(series);
  }

  return [];
};

const SHORT_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const SHORT_WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const formatDateWithDay = date => `${SHORT_MONTHS[date.getMonth()]} ${date.getDate()} (${SHORT_WEEKDAYS[date.getDay()]})`;

const pointValue = point => point.count != null ? point.count : (point.rate || 0);


const buildSingleDayBucket = (series, preset) => {
  const date = new Date();
  if (preset === "yesterday") date.setDate(date.getDate() - 1);
  const sum = series.reduce((total, point) => total + pointValue(point), 0);
  return [{ label: formatDateWithDay(date), value: parseFloat(sum.toFixed(2)) }];
};


const buildDailyPoints = series =>
  series.map(point => {
    const date = new Date(point.date || point.activityDate);
    return { label: formatDateWithDay(date), value: pointValue(point) };
  });


export const resolveChartData = (apiResponse, preset) => {
  if (apiResponse?.chartData?.length) {
    return apiResponse.chartData;
  }
  return buildChartData(apiResponse?.series || [], preset);
};
